import {Injector} from "@angular/core"
import {RunBackendJobOperationJobDetailsFragment as JobData} from "@app/common/models/background-operation/run-backend-job-operation/run-backend-job-operation.generated"
import {Settings} from "@app/common/models/settings/settings"
import {FilesService} from "@app/common/services/files/files.service"
import {JobNodes} from "@cm/job-nodes/job-nodes"
import {Utility} from "@cm/job-nodes/utility"
import {graphToJson} from "@cm/utils"
import {RunBackendJobOperation} from "@common/models/background-operation/run-backend-job-operation"
import {CM_LOGGER_API} from "@common/services/logging/index"
import {JobType} from "@generated"

function jobGraphForBatchDownload(resultFileName: string, organizationLegacyId: number, dataObjectsForDownload: Map<string, number>) {
    const filesForDownload = new Map<string, Utility.Zip.File>(
        Array.from(dataObjectsForDownload).map(([key, value]) => [
            key,
            {type: "utilityZipFile" as const, content: {type: "dataObjectReference" as const, dataObjectId: value}},
        ]),
    )

    const zipTaskInput = {
        root: {
            type: "utilityZipFolder" as const,
            content: Object.fromEntries(filesForDownload),
        },
        filename: resultFileName,
        destination: {type: "tmpDownloadData" as const, customerId: organizationLegacyId},
    }

    return JobNodes.jobGraph(
        JobNodes.task(Utility.Zip.task, {
            input: JobNodes.value(zipTaskInput),
        }),
        {
            platformVersion: Settings.APP_VERSION,
        },
    )
}

export class BatchDownloadOperation extends RunBackendJobOperation {
    constructor(
        injector: Injector,
        description: string,
        private resultFileName: string,
        organizationLegacyId: number,
        dataObjectsForDownload: Map<string, number>,
    ) {
        const onBatchDownloadJobCompleted = (jobData: JobData, setResult: (result: {url: string; title: string}) => void) => {
            this.resultUrl = jobData.output?.downloadUrl
            this.resultTitle = "Download link"
            if (!this.resultUrl) return

            setResult({url: this.resultUrl, title: this.resultTitle})
            FilesService.downloadFile(this.resultFileName, this.resultUrl)
        }

        const logger = injector.get(CM_LOGGER_API)

        super(
            injector,
            "Download",
            `Preparing: ${description}`,
            {
                jobType: JobType.BatchDownload,
                name: "Batch download",
                graph: graphToJson(jobGraphForBatchDownload(resultFileName, organizationLegacyId, dataObjectsForDownload), logger),
                organizationLegacyId,
            },
            onBatchDownloadJobCompleted,
        )
    }

    async startOperation() {
        return this.submitJob()
    }
}
